import { combineReducers } from '@ynap/reducer-utils';
import * as reducers from './reducers';

const contentReducer = combineReducers(reducers);

export default contentReducer;
